<div *ngIf="!parentField; else tplParentValidation" @fadeInAnimation>
  <div class="container-error" *ngIf="field && field.invalid && field.touched" [ngClass]="{'left': position === 'left', center: position === 'center',
    right: position === 'right', 'tw-absolute': positionAbsolute }">
    <ng-template #tplIconDescription>
      <i *ngIf="description" nz-popover="" nzPopoverTitle="" [nzPopoverContent]="descriptionTpl" nz-icon nzType="info-circle" nzTheme="outline"></i>
      <ng-template #descriptionTpl>
        <div class="content-description">
          <p> {{ description }} </p>
        </div>
      </ng-template>
    </ng-template>
    <p nz-typography [nzType]="type ? type : 'danger'" *ngIf="field.hasError('required')" @fadeInAnimation>
      <ng-container *ngTemplateOutlet="tplIconDescription"></ng-container>
      {{ message ? message : 'Campo requerido' }}
    </p>
    <p nz-typography [nzType]="type ? type : 'danger'" *ngIf="field.hasError('cpError')" @fadeInAnimation>
      <ng-container *ngTemplateOutlet="tplIconDescription"></ng-container>
      {{ message ? message : field.errors.cpError.message }}
    </p>
    <p nz-typography [nzType]="type ? type : 'danger'" *ngIf="field.hasError('phoneError')" @fadeInAnimation>
      <ng-container *ngTemplateOutlet="tplIconDescription"></ng-container>
      {{ message ? message : field.errors.phoneError.message }}
    </p>
    <p nz-typography [nzType]="type ? type : 'danger'" *ngIf="field.hasError('minlength')" @fadeInAnimation>
      <ng-container *ngTemplateOutlet="tplIconDescription"></ng-container>
      {{ message ? message : 'Mínimo de caracteres ' + field.errors.minlength?.requiredLength }}
    </p>
    <p nz-typography [nzType]="type ? type : 'danger'" *ngIf="field.hasError('maxlength')" @fadeInAnimation>
      <ng-container *ngTemplateOutlet="tplIconDescription"></ng-container>
      {{ message ? message : 'Máximo de caracteres ' + field.errors.maxlength?.requiredLength }}
    </p>
    <p nz-typography [nzType]="type ? type : 'danger'" *ngIf="field.hasError('min')" @fadeInAnimation>
      <ng-container *ngTemplateOutlet="tplIconDescription"></ng-container>
      {{ message ? message : 'Valor mínimo ' + field.errors.min?.requiredMin }}
    </p>
    <p nz-typography [nzType]="type ? type : 'danger'" *ngIf="field.hasError('max')" @fadeInAnimation>
      <ng-container *ngTemplateOutlet="tplIconDescription"></ng-container>
      {{ message ? message : 'Valor máximo ' + field.errors.min?.requiredMax }}
    </p>
    <p nz-typography [nzType]="type ? type : 'danger'" *ngIf="field.hasError('mindate')" @fadeInAnimation>
      <ng-container *ngTemplateOutlet="tplIconDescription"></ng-container>
      {{ message ? message : 'Fecha mínima ' + field.errors.mindate?.requiredMinDate | date:formatDate.DDMMYYYY }}
    </p>
    <p nz-typography [nzType]="type ? type : 'danger'" *ngIf="field.hasError('maxdate')" @fadeInAnimation>
      <ng-container *ngTemplateOutlet="tplIconDescription"></ng-container>
      {{ message ? message : 'Fecha máxima ' + field.errors.maxdate?.requiredMaxDate | date:formatDate.DDMMYYYY }}
    </p>
    <p nz-typography [nzType]="type ? type : 'danger'" *ngIf="field.hasError('invalidEmail')" @fadeInAnimation>
      <ng-container *ngTemplateOutlet="tplIconDescription"></ng-container>
      {{ message ? message : 'Correo electrónico inválido' }}
    </p>
    <p nz-typography [nzType]="type ? type : 'danger'" *ngIf="field.hasError('invalidURL')" @fadeInAnimation>
      <ng-container *ngTemplateOutlet="tplIconDescription"></ng-container>
      {{ message ? message : 'URL inválida' }}
    </p>
  </div>
</div>

<!-- Validaciones para cuando se depende de otro fieldo input -->
<ng-template #tplParentValidation>
  <i *ngIf="description" nz-popover="" nzPopoverTitle="" [nzPopoverContent]="description" nz-icon nzType="info-circle" nzTheme="outline"></i>
  <div class="container-error" *ngIf="field.invalid && field.touched">
    <p nz-typography [nzType]="type ? type : 'danger'" *ngIf="field.hasError('invalidEmail')"> {{ message ? message : 'Correo electrónico inválido' }}
    </p>
    <p nz-typography [nzType]="type ? type : 'danger'" *ngIf="field.hasError('required')"> {{ message ? message : 'Campo requerido' }} </p>
    <p nz-typography [nzType]="type ? type : 'danger'" *ngIf="field.hasError('confirm')"> {{ message ? message : 'Los campos no coinciden' }} </p>
    <!-- <div *ngIf="!field.hasError('required') && parentField && parentField.touched">
      <p nz-typography [nzType]="type ? type : 'danger'" *ngIf="field.hasError('minlength')"> Los caracteres deben ser mayor a {{ field.errors.minlength?.requiredLength }} </p>
      <p nz-typography [nzType]="type ? type : 'danger'" *ngIf="field.hasError('maxlength')"> Los caracteres deben ser menor a  {{ field.errors.maxlength?.requiredLength }} </p>
      <p nz-typography [nzType]="type ? type : 'danger'" *ngIf="field.hasError('min')"> El valor debe ser mayor a {{ field.errors.min?.requiredLength }} </p>
      <p nz-typography [nzType]="type ? type : 'danger'" *ngIf="field.hasError('max')"> El valor debe ser menor a {{ field.errors.max?.requiredLength }} </p>
      <p nz-typography [nzType]="type ? type : 'danger'" *ngIf="field.hasError('minDate')"> La fecha debe ser mayor a {{ field.errors.minDate | date:formatDate.DDMMYYYY }} </p>
      <p nz-typography [nzType]="type ? type : 'danger'" *ngIf="field.hasError('maxDate')"> La fecha debe ser menor a {{ field.errors.maxDate | date:formatDate.DDMMYYYY }} </p>
    </div> -->
  </div>
</ng-template>
